import { connect, Formik } from 'formik'
import { ChangeEventHandler, useEffect } from 'react'
import ReactToggle from 'react-toggle'
import styled from 'styled-components'

type ToggleProps = {
  name: string
  label?: string
  disabled: boolean
  checked: boolean
  ariaLabel?: string
  onChange?: ChangeEventHandler
  formik: Formik
}

const ToggleContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
`

const Label = styled.label`
  color: #4b4b4b;
  font-size: 0.875rem;
  font-weight: bold;
  display: block;
  margin-right: auto;
  margin-bottom: 0;
`

const Toggle = ({ label, name, disabled, checked, ariaLabel, onChange, formik }: ToggleProps) => {
  useEffect(
    () => {
      formik.setFieldValue(name, checked || false)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [name, checked]
  )

  const handleChange = (e: any) => {
    if (onChange) {
      onChange(e)
    } else {
      formik.setFieldValue(name, !checked)
    }
  }

  return (
    <ToggleContainer>
      {label ? <Label htmlFor={name}>{label}</Label> : null}
      <ReactToggle name={name} checked={checked} disabled={disabled} aria-label={ariaLabel} onChange={handleChange} />
    </ToggleContainer>
  )
}

export default connect(Toggle)
